__turbopack_context__.v({
  "filterBar": "FilterBar-module-scss-module__osOYeW__filterBar",
  "pillCount": "FilterBar-module-scss-module__osOYeW__pillCount",
  "pillHidden": "FilterBar-module-scss-module__osOYeW__pillHidden",
  "pillPopover": "FilterBar-module-scss-module__osOYeW__pillPopover",
  "pillTrigger": "FilterBar-module-scss-module__osOYeW__pillTrigger",
  "pills": "FilterBar-module-scss-module__osOYeW__pills",
  "viewFiltersButton": "FilterBar-module-scss-module__osOYeW__viewFiltersButton",
});
